import {
    Component,
    EventEmitter,
    TemplateRef,
    Input,
    Output
} from '@angular/core';

@Component({
    selector: 'pm-area-chart',
    //templateUrl: './app/controls/components/chart/area-chart/area-chart.html'
    templateUrl: './area-chart.html',
})
export class AreaChartComponent {

}


// WEBPACK FOOTER //
// C:/Users/jjarvis/projects/pm-controls/source/app/controls/components/chart/area-chart/area-chart-component.ts